import accounting from '../../mixins/accounting';

require('./scss/slider.scss');

export default {
    name: 'slider',

    template: `
        <div id="slider">
            <div class="row range-slider-values m-0">
                <input
                    ref="minValue"
                    class="slider-input pl-3" 
                    type="text" 
                    :value="formattedValue(minValue)" 
                    @change="setSliderValues($event, 'min')"
                />
                <span class="dash"></span>
                <input 
                    ref="maxValue"
                    class="slider-input pl-3" 
                    type="text" 
                    :value="currentValue ? formattedValue(currentValue) : formattedValue(maxValue)" 
                    @change="setSliderValues($event, 'max')"
                />
            </div>
            <input
                type="range"
                class="form-range w-100 input-range-custom"
                ref="sliderInput"
                :min="Math.floor(minValue)"
                :max="Math.round(maxValue)"
                :value="currentValue || maxValue"
                @input="setSliderValues($event, 'max')"
            />
        </div>
    `,

    mixins: [ accounting ],

    props: [
        'type', 'minValue', 'maxValue', 'setMinValue', 'setMaxValue', 'currency',
    ],

    data(){
        return {
            currentValue: this.maxRangeValueDefault,
            invalid: true,
        };
    },
    computed: {
        maxRangeValueDefault: {
            get() {
                return this.maxValue;
            },
            set(val) {
                this.maxValue = val;
            },
        },
    },
    methods: {
        formattedValue(value) {
            let formattedValue = value;

            if (this.type === 'price') {
                formattedValue = this.formatMoney(value, this.currency.code);
            }
            return formattedValue;
        },
        setSliderValues(event, valueType) {
            const target = event.target;
            const val = Number(target.value.replace(/\D/g,''));
            const min = Number(this.minValue);
            const max = Number(this.maxValue);
            this.invalid = true;

            if (valueType === 'min') {
                if (val <= this.currentValue) {
                    this.changeSlider(this.currentValue, val, val, max);
                    this.setMinValue(val);
                }

                if (this.invalid) {
                    this.$refs.minValue.value = this.formattedValue(min);
                }
            } else if (valueType === 'max') {
                if (val >= min) {
                    this.changeSlider(val, min, min, max);
                    this.setMaxValue(val);
                    this.currentValue = val;
                }

                if (this.invalid) {
                    this.$refs.maxValue.value = this.formattedValue(max);
                }
            }
        },
        changeSlider(currentMax, currentMin, min, max) {
            this.invalid = false;
            this.$refs.sliderInput.style.backgroundSize = (currentMax - currentMin) * 100 / (max - min) + '% 100%';
        }
    }

}
